import { render, staticRenderFns } from "./IdentityView.vue?vue&type=template&id=8f4c86a2&scoped=true&"
import script from "./IdentityView.vue?vue&type=script&lang=js&"
export * from "./IdentityView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityView.vue?vue&type=style&index=0&id=8f4c86a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4c86a2",
  null
  
)

export default component.exports